
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useLeagueList } from '@/modules/league/model/list';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { timeUnits } from '@/common/utils/helpers';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, actions } = useLeagueList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Option, label: 'Time Unit', key: 'timeUnit', options: timeUnits },
                { type: TableColumnType.Text, label: 'Time Duration', key: 'timeDuration' },
                { type: TableColumnType.Text, label: 'Max Player', key: 'maxPlayer' },
                { type: TableColumnType.Text, label: 'Default Point', key: 'defaultPoint' },
                { type: TableColumnType.Text, label: 'Penalty Point', key: 'penaltyPoint' },
                { type: TableColumnType.Text, label: 'Position Points', key: 'positionPoints' },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.DateTime, label: 'Next Start Time', key: 'nextStartTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-layer-group',
                        theme: 'info',
                        tooltip: 'Tier',
                        to: { name: ROUTE_NAME_LEAGUE.TIER.INDEX, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_LEAGUE.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_LEAGUE };
    }
});
